// extracted by mini-css-extract-plugin
module.exports = {"subscriptionBoxTitle":"styles_subscriptionBoxTitle__UWP6F","subscriptionBoxSubTitle":"styles_subscriptionBoxSubTitle__Rm7Nq"};